import React from "react";
import _Toggle from "react-toggle";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-toggle/style.css";

// TypeScript fix: cast to a valid React component type
const Toggle = _Toggle as unknown as React.ComponentType<any>;

interface ToggleInputProps {
    tooltipId?: string;
    tooltipContent?: string;
    disabled?: boolean;
    [key: string]: any; // for additional props like checked, onChange, etc.
}

const ToggleInput: React.FC<ToggleInputProps> = ({
    tooltipId,
    tooltipContent = "",
    disabled = false,
    ...rest
}) => {
    return (
        <>
            <div data-tooltip-id={tooltipId}>
                <Toggle
                    disabled={disabled}
                    {...rest}
                    icons={{
                        unchecked: null,
                        checked: null,
                    }}
                />
            </div>

            {tooltipId && (
                <ReactTooltip
                    id={tooltipId}
                    place="bottom"
                    content={tooltipContent}
                />
            )}
        </>
    );
};

export default ToggleInput;
